export const { VITE_API_PREFIX: API_URL, VITE_APP_ENV: APP_ENV } = import.meta.env;
